import { useQuery } from '@apollo/client'

import { useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { Tab, TabList, TabPanel, Tabs, FloraTypography, Flex, Box, Spinner } from '@grupoboticario/flora-react'

import ClubProfile from '@/components/ClubProfile/ClubProfile'
import ExtractPoints from '@/components/ExtractPoints/ExtractPoints'
import RegisterData from '@/components/RegisterData/RegisterData'
import { useHeaderContext } from '@/context/header'
import { useUserContext } from '@/context/user'
import { GET_MEMBER_BY_DOCUMENT_NUMBER } from '@/graphql/queries/memberByDocumentNumber'
import { ExtractBar } from '@/icons/ExtractBar'
import { UserBar } from '@/icons/UserBar'
import { UsersBar } from '@/icons/UsersBar'
import { Actions } from '@/utils/dictionaries/actionsDictionary/actions'
import { FadeIn } from '@/utils/useFadeIn/useFadeIn'

import * as M from '../member.styles'

const EditUserPage = () => {
  const { member, setMember, setMemberStatus } = useHeaderContext()
  const { hasPermission } = useUserContext()
  const { member: documentNumber } = useParams()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const { data, loading, refetch } = useQuery(GET_MEMBER_BY_DOCUMENT_NUMBER, {
    variables: { documentNumber: documentNumber },
    skip: !documentNumber
  })

  useEffect(() => {
    if (searchParams?.get?.('refresh') && documentNumber) {
      navigate(`/members/${documentNumber}`)
      refetch()
    }
  }, [documentNumber, navigate, refetch, searchParams])

  useEffect(() => {
    if (data?.member?.documentHash) {
      setMember({
        ...data?.member,
        username: `${data?.member?.givenName} ${data?.member?.familyName}`
      })
    }
  }, [loading, data, documentNumber, setMember])

  useEffect(() => {
    return () => {
      setMember({})
      setMemberStatus({ status: null, isBlocked: false })
    }
  }, [setMember, setMemberStatus])
  return (
    <>
      {loading && (
        <FadeIn>
          <Box css={M.getLoadingBoxCss(loading)}>
            <Spinner size="lg" speed="800ms" thickness="2px" />
          </Box>
        </FadeIn>
      )}
      {!loading && (
        <FadeIn>
          <Tabs defaultValue="data">
            <TabList aria-label="Tabela de edição do cliente" css={M.tabListCss}>
              <Tab value="data">
                <Flex align="center" gap="$3">
                  <UserBar />
                  <FloraTypography fontSize="bodySmallStandard">Dados cadastrais</FloraTypography>
                </Flex>
              </Tab>
              <Tab value="club">
                <Flex align="center" gap="$3">
                  <UsersBar />
                  <FloraTypography fontSize="bodySmallStandard">Perfil do Clube</FloraTypography>
                </Flex>
              </Tab>
              {hasPermission(Actions.LIST_EXTRACT) && (
                <Tab value="points">
                  <Flex align="center" gap="$3">
                    <ExtractBar />
                    <FloraTypography fontSize="bodySmallStandard">Extrato de pontos</FloraTypography>
                  </Flex>
                </Tab>
              )}
            </TabList>
            <TabPanel value="data">
              <FadeIn>
                <Box>{!!member?.documentNumber && <RegisterData documentNumber={member?.documentNumber} />}</Box>
              </FadeIn>
            </TabPanel>
            <TabPanel value="club">
              <FadeIn>
                <Box>
                  {documentNumber && <ClubProfile documentNumber={documentNumber} onUpdate={() => refetch()} />}
                </Box>
              </FadeIn>
            </TabPanel>
            {hasPermission(Actions.LIST_EXTRACT) && (
              <TabPanel value="points">
                <FadeIn>
                  <Box>{member?.documentHash && <ExtractPoints />}</Box>
                </FadeIn>
              </TabPanel>
            )}
          </Tabs>
        </FadeIn>
      )}
    </>
  )
}

export default EditUserPage

export { EditUserPage as EditMemberPage }
